import { PosterLayer } from "@manager/layer/PosterLayer";
import React from "react";
import { AspectRatioHelper } from "../../utils/AspectRatioHelper";
import { WindowResizeHelper } from "../../utils/WindowResizeHelper";

import "@styles/c-posterLayer.scss";

interface Props {
  className?: string;
}

interface State {
  aspectRatio?: number;
  width: number;
  height: number;
  posterUrl?: string;
}

export class PosterLayerComponent extends React.Component<Props, State> implements PosterLayer {

  private container: HTMLElement;

  constructor(props: Props) {
    super(props);
    this.state = {
      width: 0,
      height: 0
    };
  }

  render() {
    const { className } = this.props;
    return (
      <div
        className={`${className || ""} c-posterLayer`}
        ref={(element) => this.container = element}
      >
        {this.state.posterUrl &&
          <img
            className="c-posterLayer__poster"
            src={this.state.posterUrl}
            style={{
              width: `${this.state.width}px`,
              height: `${this.state.height}px`
            }}
          />
        }
      </div>
    );
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowResize);
  }

  // start of PosterLayer implementation
  setAspectRatio(aspectRatio: number) {
    this.setState({
      aspectRatio,
      ...AspectRatioHelper.calculateDimensions(aspectRatio, this.container.clientWidth, this.container.clientHeight)
    });
  }

  showPoster(url: string): void {
    this.setState({
      posterUrl: url
    });
  }

  hidePoster(): void {
    this.setState({
      posterUrl: undefined
    });
  }

  getIsShowingPoster(): boolean {
    return !!this.state.posterUrl;
  }
  // end of PosterLayer implementation

  private recalculateDimensions() {
    if (this.container && this.state.aspectRatio) {
      this.setState({
        ...AspectRatioHelper.calculateDimensions(this.state.aspectRatio, this.container.clientWidth, this.container.clientHeight)
      });
    }
  }

  private handleWindowResize = () => {
    WindowResizeHelper.doOnResize(() => this.recalculateDimensions());
  }

}
